import { ParticipationGridColDef, ParticipationRecordItem } from '../../types';

export type Value = ParticipationRecordItem['linkedCmgEntityKey'];

export const linkedCMGEntityKeyColDef: ParticipationGridColDef<Value> = {
  field: 'linkedCmgEntityKey',
  headerName: 'Linked CMG Entity Key',
  filter: 'agTextColumnFilter',
  floatingFilter: true,
};
